<template>
    <div v-if="student">
        <router-link :to="{ name: 'my_students' }">&larr; Back to My Students</router-link>
        <b-card class="mt-4">
            <h4 class="card-title">{{ name }} &mdash; {{ age }} years old.</h4>
            <router-link
                v-if="settings.ALLOW_REGISTRATION && student.enrolled"
                :to="{ name: 'register_student', params: { id: student.id }}"
                class="sc-btn pill"
            >
                Change Registration
            </router-link>
            <router-link
                :to="{ name: 'parent_edit_student', params: { id: student.id }}"
                class="sc-btn pill"
            >
                Edit Student
            </router-link>
            <router-link :to="{ name: 'student_settings', params: { id: student.id } }" class="bottom-cog float-right">
                <font-awesome-icon icon="cog" size="lg"></font-awesome-icon>
            </router-link>
        </b-card>
        <div class="mt-2">
            <div v-if="currentClasses" class="m-2 text-center">
                <button
                    class="sc-btn pill"
                    @click="showHistory()"
                    style="width: 100px;"
                >
                    <font-awesome-icon icon="history" class="mr-2"></font-awesome-icon> History
                </button>
            </div>
            <div v-else class="m-2 text-center">
                <button
                    class="sc-btn pill"
                    @click="currentClasses = true"
                    style="width: 100px;"
                >
                    <font-awesome-icon icon="arrow-left" class="mr-2"></font-awesome-icon> Back
                </button>
            </div>
            <div v-if="currentClasses">
                <!--{{ failed }} {{ working}}-->
                <div v-if="classes.length != 0">
                    <b-card
                        v-for="(Class, idx) in classes"
                        v-bind:key="idx" 
                        :title="Class.class_name"
                        :sub-title="[time(Class.start_time), time(Class.end_time)].join('-')"
                        tag="article"
                        class="mt-2 border"
                    >
                        <b-card-text>
                            {{ Class.description }}
                        </b-card-text>
                        <div class="text-center">
                            <b-button
                                v-b-modal.modal-1
                                class="mr-2"
                                variant="primary"
                                @click="selectClass(Class)"
                            >
                                <font-awesome-icon icon="address-book"></font-awesome-icon> Contact Teacher
                            </b-button>
                            <!--
                            <b-button href="#" variant="primary">
                                <font-awesome-icon icon="paper-plane"></font-awesome-icon> Class Page
                            </b-button>
                            -->
                        </div>
                    </b-card>
                </div>
                <div v-else-if="working" class="text-center">
                    <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div v-else-if="failed">
                    <div class="alert alert-danger">
                        <h3>Failed to fetch classes.</h3>
                        <p>Please reload the page to retry. <pre>CTRL+R</pre></p>
                    </div>
                </div>
                <div v-else-if="settings.ALLOW_REGISTRATION && !student.enrolled">
                    <div class="alert alert-secondary">
                        <h3>{{ student.first_name }} is unregistered.</h3>
                        <b-button
                            :to="{ name: 'register' }"
                            variant="primary"
                        >
                            Register Now
                        </b-button>
                    </div>
                </div>
                <div v-else>
                    <div class="alert alert-secondary">
                        <h3>Registration is not available at this time.</h3>
                    </div>
                </div>
            </div>
            <div v-else-if="semesters" class="mt-2 mb-4">
                <b-card
                    v-for="(semester, idx) in semesters" 
                    v-bind:key="idx"
                    :title="semester.label"
                    :sub-title="date(semester.start_time) + ' to ' + date(semester.stop_time)"
                    class="mt-3"
                >
                    <b-list-group flush>
                        <b-list-group-item
                            v-for="(Class, idx) in oldClasses.filter(cls => cls.semester_id == semester.id)"
                            v-bind:key="idx"
                        >
                            <a href="#" class="card-link">{{ Class.class_name }}</a>
                            <small class="float-right">{{ time(Class.start_time) }} - {{ time(Class.end_time) }}</small>
                        </b-list-group-item>
                    </b-list-group> 
                </b-card>
                <div v-if="oldClasses.length == 0">
                    <div class="alert alert-secondary">
                        <h3>There is no history to show.</h3>
                    </div>
                </div>
            </div>
            <div v-else class="mt-5">
                <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <b-modal
                id="modal-1"
                title="Contact Teacher"
                @cancel="selectClass(null)"
                @ok="selectClass(null)"
            >
                <div v-if="selectedClass != null">
                    <div
                        v-for="(contact, idx) in selectedClass.teacher_contacts"
                        v-bind:key="idx"
                    >
                        <h5>{{ contact.name }}</h5>
                        <b-input-group>
                            <b-input-group-prepend>
                                <a 
                                    class="btn btn-primary"
                                    :href="'mailto:' + contact.email"
                                >
                                    <font-awesome-icon icon="envelope"></font-awesome-icon>
                                    Email
                                </a>
                            </b-input-group-prepend>
                            <div class="form-control">
                                {{ contact.email }}
                            </div>
                        </b-input-group>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
    <div v-else class="text-center">
        <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>
<style>
    .student-view {
        margin: 2% 0%;
        padding-bottom: 10%;
    }
</style>
<script>
import { mapState } from 'vuex';

export default {
    props: ["id"],
    mounted() {
        this.fetchStudents();
        this.fetchClasses();
    },
    data: function () {
        return {
            selectedClass       : null,
            
            actions             : [
                                    { }
                                ],
            oldClasses          : [],
            semesters           : [],
            classes             : [],
            currentClasses      : true,
            failed              : false,
            working             : false
        };
    },
    computed: {
        student () {
            if (!this.students) return null;
            return this.students.filter(s => s.id == this.id)[0];
        },
        name () {
            return `${this.student.first_name} ${this.student.last_name}`;
        },
        age () {
            return this.$moment().diff(this.student.birthdate, "years");
        },
        ...mapState([
                        "students",
                        "settings"
                    ])
    },
    methods: {
        selectClass(Class) {
            this.selectedClass = Class;
        },
        fetchStudents() {
            this.$api.get("/api/register/get-students").then((response) => {
                const data = response.data;
                if (data.students.length) {
                    this.$store.commit("updateStudents", data);
                }
            });
        },
        fetchClasses() {
            this.working = true;
            this.$api.get(
                "/api/student/classes/enrolled",
                { params: { student_id: this.id } }
            ).then((request) => {
                this.working = false;
                const data = request.data;
                if (!data.fetched) {
                    this.failed = true;
                } else {
                    this.classes = data.classes;
                }
            });
        },
        showHistory () {
            this.currentClasses = false;
            if (this.semesters.length == 0) {
                this.$api.get(
                    "/api/student/classes/history",
                    { params: { student_id: this.id } }
                ).then(({ data: { classes, semesters } }) => {
                    this.oldClasses = classes;
                    this.semesters  = semesters;
                });
            }
        },
        date (dt) {
            return this.$moment(dt).format("LL");
        },
        time (t) {
            return this.$moment("2012-12-31T"+t).format("hh:mm a");
        }
    }
}
</script>